import { useState } from "react";

// redux
import { useSelector } from 'react-redux';
import { selectCountry } from '../../../hyc-store/reducers/countries/countriesReducer';

// controllers
import { ProductController } from "controllers";

// components
import { Hero } from "shared/components/bulma/hero";
import { CustomerCard } from "./customer-card";
import { CustomersFilterBarTimed } from "shared/components/bulma/customers-filter-bar";

const SEARCH_LIMIT = 150;
const QUERY_LIMIT_CHARS = 2;

const Helper = () => (
    <div className="container has-text-centered">
        <p className="title is-size-1">
            Type to find customers
        </p>
        <p className="subtitle">
            <span className="icon">
                <i className="fas fa-keyboard"></i>
            </span>
        </p>
    </div>
);

const Loader = () => (
    <progress className="progress is-large is-primary" max="100"></progress>
);

const ResultStats = ({ customers }) => (
    <div className="tags has-addons">
        <span className="tag is-primary">matches</span>
        <span className="tag is-primary is-light">{customers.length}</span>
    </div>
);

const CustomerSearch = () => {
    const [isDirty, setDirty] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const country = useSelector(selectCountry);

    const handleFilterBarChange = (event) => {
        if (!event?.target) {
            return;
        }

        const { value } = event.target;
        const { select, input } = value;

        const query = input.trim();
        if (select && query && query.length >= QUERY_LIMIT_CHARS) {
            search({ field: select, query });
        } else if (query === '') {
            setDirty(false);
            setCustomers([]);
        }
    }

    const search = async ({ field, query }) => {
        setDirty(true);
        setLoading(true);

        const results = await ProductController.getUsersByFieldQuery(field, query, SEARCH_LIMIT, country, false);

        setCustomers(results);
        setLoading(false);
    };

    const StatsBlock = () => {
        if (isLoading) {
            return <p className="is-size-6 is-dark">Searching for customers...</p>;
        }

        if (isDirty) {
            return (
                <ResultStats customers={customers} />
            );
        }

        return null;
    }

    const ResultBlock = () => {
        if (isLoading) {
            return <Loader />
        }

        if (!isDirty) {
            return <Helper />
        }

        return (
            <div className="columns is-multiline">
                {customers.map((customer) => (
                    <div key={customer.id} className="column is-3">
                        <CustomerCard customer={customer} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            <Hero className="is-light is-small">
                <div className="block">
                    <CustomersFilterBarTimed timer="500" onChange={handleFilterBarChange} />
                </div>

                <div className="block">
                    <StatsBlock />
                </div>
            </Hero>

            <Hero>
                <ResultBlock />
            </Hero>
        </>
    );
};

export { CustomerSearch };
